import type { ApiService } from '@ibe/services';
import { useApi as useLibApi } from '@ibe/components';
import { useGlobalMGLProps } from '@/Util/GlobalMGLPropsContext';
import type {
  FetchParams,
  Middleware as IbeApiMiddleware,
  RequestContext as IbeApiRequestContext
} from '@ibe/api';
import { getCacheHeaders } from '@/Util/api';

export const useApi = (doNotCache?: boolean): ApiService => {
  const { isAuthor, fetchTTL } = useGlobalMGLProps() || {};
  return useLibApi().withMiddleware(
    new (class implements IbeApiMiddleware {
      async pre(context: IbeApiRequestContext): Promise<void | FetchParams> {
        return {
          ...context,
          init: {
            ...context.init,
            ...getCacheHeaders(isAuthor, doNotCache, fetchTTL)
          }
        };
      }
    })()
  );
};
